import axios from "axios";
import getAxios from "./axiosInstance";

const SEARCH_API_URL = "/api/Brokering?searchTerm=";
const FEATUREFLAGS_API_URL = "/api/FeatureFlags";

const fetchdata = async (URL, onSuccess, onError) => {
  try {
    const axios = await getAxios();
    const response = await axios.get(URL);
    onSuccess(response);
  } catch (error) {
    console.error(error);
    onError(error);
  }
};

let timer = 0;
const delay = (callback, ms) => {
  clearTimeout(timer);
  timer = setTimeout(() => {
    callback();
  }, ms || 0);
};

export const fetchBrokers = async (searchTerm, onSuccess, onError) => {
  searchTerm = encodeURI(searchTerm);
  delay(
    () => fetchdata(`${SEARCH_API_URL}${searchTerm}`, onSuccess, onError),
    500
  );
};

const newFetchData = async (URL) => {
  try {
    const response = await axios.get(URL);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const newFetchBrokers = async (searchTerm) => {
  searchTerm = encodeURI(searchTerm);
  return await newFetchData(`${SEARCH_API_URL}${searchTerm}`);
};

export const fetchFeatureFlags = async () => {
  try {
    const response = await axios.get(FEATUREFLAGS_API_URL);
    return response;
  } catch (error) {
    console.error(error);
  }
};
